/* Lunai deklaracije — filtering the declaration list, and named PDF
   downloads.

   The whole list is already in the DOM (every row is a native <details>),
   so search is a local filter and can therefore match the declaration
   BODY — an ingredient, an additive, a warning — not just the product
   name. Each row's haystack is folded once on init; only the query is
   folded per keystroke.

   Nothing here is required to read a declaration: <details> expands and
   the download anchor works with JS off. */
(function () {
  'use strict';

  var DEEP_LINK = /^#d-[A-Za-z0-9-]+$/;

  function fold(value) {
    return value
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/\s+/g, ' ')
      .toLowerCase();
  }

  function initSection(root) {
    /* The Theme Editor re-renders sections in place; drop the previous
       generation's listeners rather than stacking a second set. */
    if (root._dkAbort) root._dkAbort.abort();
    var controller = new AbortController();
    root._dkAbort = controller;
    var on = { signal: controller.signal };

    var input = root.querySelector('[data-dk-input]');
    var clear = root.querySelector('[data-dk-clear]');
    var countEl = root.querySelector('[data-dk-count]');
    var emptyEl = root.querySelector('[data-dk-empty]');
    var brands = Array.prototype.slice.call(root.querySelectorAll('[data-dk-brand]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-dk-item]'));

    var countOne = root.getAttribute('data-count-one') || '';
    var countMany = root.getAttribute('data-count-many') || '';
    var countNone = root.getAttribute('data-count-none') || '';
    var savedText = root.getAttribute('data-saved-text') || '';
    var helpText = root.getAttribute('data-help-text') || '';

    /* Only the parts that vary between declarations. Taking the whole row
       would fold in the 19 field labels, the button text and the legal note,
       so "deklaracijo" or "opozorilo" would match all twenty. The brand still
       matches, because it is also the value of field 2. */
    items.forEach(function (item) {
      var parts = item.querySelectorAll('.dk-row__name, .dk-row__mass, .dk-field__value');
      var text = '';
      for (var i = 0; i < parts.length; i++) text += parts[i].textContent + ' ';
      item._dkHay = fold(text);
    });

    /* Rows opened by the filter (sole match) are closed again by the
       filter; a row the visitor opened themselves is left alone. */
    var autoOpened = null;

    function setCount(shown, filtering) {
      if (!countEl) return;
      if (!filtering) { countEl.textContent = ''; return; }
      if (shown === 0) countEl.textContent = countNone;
      else if (shown === 1) countEl.textContent = countOne;
      else countEl.textContent = countMany.replace('%%', String(shown));
    }

    function apply() {
      var raw = input ? input.value.trim() : '';
      var query = fold(raw);
      var filtering = query.length > 0;
      var shown = 0;
      var sole = null;

      items.forEach(function (item) {
        var hit = !filtering || item._dkHay.indexOf(query) !== -1;
        item.hidden = !hit;
        if (hit) { shown++; sole = item; }
      });

      brands.forEach(function (brand) {
        brand.hidden = !brand.querySelector('[data-dk-item]:not([hidden])');
      });

      /* Above, `sole` is set on every hit, so it is really "last visible row".
         Collapse it to a genuine sole match, or clearing the field leaves an
         auto-opened LAST row open — it still compares equal below. */
      if (!filtering || shown !== 1) sole = null;

      if (autoOpened && autoOpened !== sole) {
        var previous = autoOpened.querySelector('[data-dk-det]');
        if (previous) previous.open = false;
        autoOpened = null;
      }
      /* One hit for a real query is almost always the product someone
         typed off a package — open it rather than making them click. */
      if (filtering && shown === 1 && raw.length > 1 && sole) {
        var details = sole.querySelector('[data-dk-det]');
        if (details && !details.open) { details.open = true; autoOpened = sole; }
      }

      if (emptyEl) emptyEl.hidden = shown !== 0;
      if (clear) clear.hidden = !filtering;
      setCount(shown, filtering);
    }

    if (input) {
      input.addEventListener('input', apply, on);
      input.addEventListener('search', apply, on);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && input.value) {
          e.preventDefault();
          input.value = '';
          apply();
        }
      }, on);
    }

    if (clear) {
      clear.addEventListener('click', function () {
        if (!input) return;
        input.value = '';
        apply();
        input.focus();
      }, on);
    }

    /* A QR code can point straight at one declaration:
       /pages/deklaracije#d-beef-kisses */
    function openFromHash() {
      var hash = window.location.hash;
      if (!DEEP_LINK.test(hash)) return;
      var target = root.querySelector(CSS.escape ? '#' + CSS.escape(hash.slice(1)) : hash);
      if (!target || !root.contains(target)) return;
      if (input && input.value) { input.value = ''; apply(); }
      var details = target.querySelector('[data-dk-det]');
      if (details) details.open = true;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    window.addEventListener('hashchange', openFromHash, on);

    /* Downloads: the anchor already works; upgrade it to a named file.
       Same contract as assets/lunai-ozadja.js — on any failure the PDF
       opens in a new tab and a quiet helper line appears. */
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-dk-dl]');
      if (!link || !root.contains(link) || link.classList.contains('is-busy')) return;
      if (!window.fetch || !window.URL || !URL.createObjectURL) return;
      e.preventDefault();

      var status = link.parentNode.querySelector('[data-dk-status]');
      link.classList.add('is-busy');
      link.setAttribute('aria-busy', 'true');
      if (status) status.textContent = '';

      fetch(link.href, { mode: 'cors' })
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.blob();
        })
        .then(function (blob) {
          var url = URL.createObjectURL(blob);
          var tmp = document.createElement('a');
          tmp.href = url;
          tmp.download = link.getAttribute('data-fname') || 'lunai-deklaracija.pdf';
          document.body.appendChild(tmp);
          tmp.click();
          tmp.remove();
          window.setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
          if (status) {
            status.textContent = savedText;
            window.setTimeout(function () {
              if (status.textContent === savedText) status.textContent = '';
            }, 3000);
          }
        })
        .catch(function () {
          window.open(link.href, '_blank', 'noopener');
          if (status) status.textContent = helpText;
        })
        .then(function () {
          link.classList.remove('is-busy');
          link.removeAttribute('aria-busy');
        });
    }, on);

    apply();
    openFromHash();
  }

  function boot() {
    document.querySelectorAll('[data-dk]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-dk]');
    if (root) initSection(root);
  });
})();
